/**
 * Send live data updates to apps
 *
 * @param {[{value:string, unit:string, arrow:string, color:string}]} data
 */
const liveDataUpdate = (data) => {
    const json = JSON.stringify(data)

    if (window?.webkit?.messageHandlers?.liveDataUpdate) {
        window.webkit.messageHandlers.liveDataUpdate.postMessage(json)
    } else if (typeof Android !== "undefined" && Android?.liveDataUpdate) {
        Android.liveDataUpdate(json)
    }
}

export { liveDataUpdate }
